import React from 'react'

export const Credits= () => {
  return (
    <footer className='container-fluid text-center bg-secondary'>
        Site by <a target='_blank' href='https://www.4digital.az/'>4Digital.az</a>
    </footer>
  )
}
